import { EntityBase } from "@common/types/entity";
import { addDays, format, formatISO, parseISO, subDays } from "date-fns";
import { Account } from "@common/types/domains/accounting/account";
import { AccountClass } from "@common/constants/domains/accounting/accounts";
import { accountClassesIncreasingByDebit } from "@common/constants/domains/accounting/helpers";
import { FinancialAccountBase } from "@common/types/financialAccount";
import { fullDateLongFormat } from "./date";

export function getEntityOpeningBalanceDate(entity: EntityBase): string {
    return formatISO(subDays(parseISO(entity.bookkeepingStartDate), 1), {
        representation: "date",
    });
}

export function getFinancialAccountOpeningBalanceDate(
    entity: EntityBase,
    financialAccount: FinancialAccountBase,
): string {
    const date =
        financialAccount.bookkeepingStartDate ?? entity.bookkeepingStartDate;
    return formatISO(subDays(parseISO(date), 1), {
        representation: "date",
    });
}

export function getFinancialAccountOpeningBalanceAdjustmentDate(
    entity: EntityBase,
    financialAccount: FinancialAccountBase,
): string {
    return financialAccount.bookkeepingStartDate ?? entity.bookkeepingStartDate;
}

export function getFinancialAccountOpeningBalanceDescription(
    entity: EntityBase,
    financialAccount: FinancialAccountBase,
): string {
    return `Opening Balance as of ${format(parseISO(getFinancialAccountOpeningBalanceDate(entity, financialAccount)), fullDateLongFormat)}`;
}

export function getDefaultOpeningBalanceAdjustmentDate(
    openingBalanceDate: string,
): string {
    return formatISO(addDays(parseISO(openingBalanceDate), 1), {
        representation: "date",
    });
}

export function shouldDebitAccountWithOpeningBalance(
    account: Account,
    openingBalance: number,
): boolean {
    if (accountClassesIncreasingByDebit.includes(account.class)) {
        return openingBalance >= 0;
    }
    return openingBalance < 0;
}

// GL exports sign balances debit-positive for every account type, but Kick
// stores opening balances by natural class direction. Negate credit-normal
// classes so shouldDebitAccountWithOpeningBalance later books them correctly.
export function migrationOpeningBalanceToKickSign(
    classification: AccountClass,
    providerBalance: number,
): number {
    return accountClassesIncreasingByDebit.includes(classification)
        ? providerBalance
        : -providerBalance;
}
